import React from 'react'
import { Modal, ModalHeader, Row, Col } from 'reactstrap';
import '../../../assets/css/pantalla1.css'
import { FormEndCancell } from './FormEndCancell';
import { Dialog } from 'primereact/dialog';



export const ModalEndCancell = (props) => {

  const {
    method2, toggle2, modal2, loading, navigateInicio, getEncuestaCancell, surnames, nameModal, loading2, modalPrueba, surname, modalPrueba2, loadingPatient
  } = props;


  return (
    <Dialog
      header={"Gracias" ?? "---"}
      visible={modal2}
      headerStyle={{
        backgroundColor: "#0d3b59",
        color: 'white',
        fontWeight: 'bold',
      }}
      pt={{
        header: { style: { backgroundColor: "#0d3b59", color: 'white' } },
        headerIcon: { style: { color: 'white' } },
      }}
      onHide={toggle2}
      className="medium-dialog"

    >

      {
        method2 === "listEnd"
          ? <FormEndCancell
            button="Guardar"
            {...{ toggle2, loading2, navigateInicio, getEncuestaCancell, surnames, nameModal, modalPrueba, surname, modalPrueba2, loadingPatient }}
          />
          :
          ""
      }

    </Dialog>

  )
}
